import React from 'react';
import {PostList} from '../../post/postList';
import '../../post/style/postfeed.css';

const Content = ({apiCall,bookMarks ,postList,cursor,users}) => {

  return (

      <div className={'postfeedContainer'}>
          <div className={'postFeed'}>
              <PostList users={users} apiCall={apiCall} bookmarks={bookMarks} posts={postList} cursor={cursor}/>
          </div>
      </div>

  )
}
export default Content;
